var _a;
import { inPerson, telehealth } from './strings';
export var AppointmentMedium;
(function (AppointmentMedium) {
    AppointmentMedium["video"] = "VIDEO";
    AppointmentMedium["phone"] = "PHONE";
    AppointmentMedium["inPerson"] = "IN_PERSON";
})(AppointmentMedium || (AppointmentMedium = {}));
export var appointmentMediumLabels = (_a = {},
    _a[AppointmentMedium.video] = telehealth,
    _a[AppointmentMedium.phone] = telehealth,
    _a[AppointmentMedium.inPerson] = inPerson,
    _a);
